import React, { useContext, useEffect, useState } from "react";
import { BgColorToTextColorMapFunc } from "../../CodesToColorMap";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";

export const NavFooter = ({
	children,
	bgColor,
	textColor,
	smallPrint,
	isBorderOff,
	currentTheme,
}) => {
	const borderClasses = isBorderOff
		? ""
		: "border-t-2 border-white footerShadow";

	const context = useContext(DiseaseGroupContext);

	const [theme, setTheme] = useState(currentTheme);

	useEffect(() => {
		if (theme) {
		} else {
			setTheme(context.theme.primary());
		}
	}, []);

	let blurClasses = "backdrop-blur-sm bg-opacity-20";

	// switch (theme.group) {
	// 	case "meso":
	// 		blurClasses = "backdrop-blur-sm bg-opacity-20";
	// 		break;
	// 	case "lcn":
	// 	default:
	// 		blurClasses = "backdrop-blur-md bg-opacity-20";
	// 		break;
	// }

	return (
		<div
			className={`${borderClasses} p-safeAreaBottom pt-2.5 bg-white backdrop-filter ${blurClasses} firefox:bg-opacity-95`}
		>
			<div
				className={`max-w-xl mx-auto flex flex-col px-3 z-10 max-h-28 text-${
					textColor ? textColor : BgColorToTextColorMapFunc(theme)
				}`}
			>
				<div className={"flex justify-between content-center my-1 mx-3 gap-2"}>{children}</div>
				{smallPrint ? (
					<small
						className={
							"text-xs text-black font-light italic text-center tracking-tight mt-2"
						}
					>
						{smallPrint}
					</small>
				) : null}
			</div>
		</div>
	);
};
